import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { BASE_API_URL } from '../utils/constants';
import { Stack, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import "./CourseMaster.css";
import CircularProgress from "@mui/material/CircularProgress";
// import AddMorePopup from "./AddMorePopup";
// import EditPopup from "./EditPopup";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CSVLink } from "react-csv";
import { IoMdDownload } from "react-icons/io";
import DeleteConfirmationModal from "../utils/DeleteConfirmationModal";

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
  },
});
const columns = [
  { id: "sno", label: "SL.#", align: "center" },
  {
    id: "primary_skill",
    label: "Primary Skill",
    align: "center",
  },
  {
    id: "span",
    label: "Span",
    align: "center",
  },
  {
    id: "ssi_bundle",
    label: "SSI Bundle",
    align: "center",
  },
  {
    id:"edit",
    label:"Edit",
    align:"center"
  }
];

const CourseMaster = () => {

   const theme = createTheme({
      typography: {
        fontFamily: "Graphik-Regular",
      },
    });
    const [open, setOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [searchVal, setSearchVal] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [severity, setSeverity] = useState('');
    const [openEdit, setOpenEdit] = React.useState(false);
    const [smeName, setSmeName] = useState();
    const [courseCode, setcourseCode] = useState();
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [uploadStatusMsg, setUploadStatusMsg] = useState('');
    const [courses,setCourses]= useState([]);
    
    const searchFunction = (e) => {
      setSearchVal(e.target.value);
      setPage(0);
    };


  const fetchCourses= async()=>{
    setLoading(true);
    try{
      const response= await axios.get(`${BASE_API_URL}/bundleSkills/courses`,
        {
          headers:{
            Authorization:localStorage.getItem("token")
          }
        }
      );
      setCourses(response?.data);
      console.log(response?.data);
    }catch(err){
      console.error("Error in fetching bundle Skills courses ", err);
      alert("Failed to fetch the courses. Please try again later.");
    }finally{
      setLoading(false);
    }
  }

  useEffect(()=>{
    fetchCourses();
  },[]);

    let filteredData;
  filteredData = courses
  // .filter((val, i) =>
  //   (val.courseName).toLocaleLowerCase().includes(searchVal.toLocaleLowerCase())
  // );

  const headers = [
    { label: "Primary Skill", key: "primary_skill"},
    { label: "Span", key: "span" },
    { label: "SSI Bundle", key: "ssi_bundle" }
  ];

  const handleDelete = async(id) => {
      setOpen(null);
    try{      
      const response= await axios.delete(`${BASE_API_URL}/bundleSkills/course/${id}`,{
            headers: {
            Authorization: localStorage.getItem("token"),
          }
        }
      );
      alert("Deleted course Successfully!");
      setCourses(prevState => prevState.filter(course => course.id!==id));

    }catch{
      alert("Failed to delete!");
    }finally{
      setDeleting(false);
    }
  }

    const handleTemplateCourseDownload = async () => {
    try {      
      let fileUrl = process.env.PUBLIC_URL + "/template/Template_CourseMaster-BundleSkills.xlsx";
      let fileName = `template_coursesData-.xlsx`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();  
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}`;
      link.target = "_blank";        
      document.body.appendChild(link);
      link.click();  
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  }

   const handleUpload = async() => {
    const formData = new FormData();
    formData.append("file", file);

    try{
      const response= await axios.post(`${BASE_API_URL}/bundleSkills/coursefile`, 
        formData,{
        headers: {
          Authorization: localStorage.getItem("token"),
        }
      }
      );
      setIsFileUploaded(true);
      setFile(null);
      alert("Uploaded Courses successfully")
      fetchCourses();
      if (ref.current) {
        ref.current.value = null; // Reset the file input
      }
    }catch(err){
      console.log('err', err)
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

  
  
    const ref = useRef();
    const saveFile = (e) => {
      setFile(e.target.files[0]);
    };

  if(loading){
    return "Loading...";
  }

  return (<>
    <ThemeProvider theme={theme}>
            <Stack sx={{ marginTop: "0px" }}>
              <Stack>
                <h3 className="upload_section_header">Course Master Data</h3>
                <p className="upload_section_para">
                  This section lists the courses that are offered by L&TT. You as Admin can Add new
                  courses or edit the existing ones.
                </p>
              </Stack>
              <div className="course-actions-header">
                <div className="download_section">
                  <div className="training-courses-download">
                    <CSVLink data={courses} headers={headers} filename={"coursedata_bundleSkills.csv"} target="_blank" className="training-courses-download-btn">
                      Courses Master <IoMdDownload style={{"vertical-align": "text-bottom",marginLeft: "2px"}} />
                    </CSVLink>
                  </div>
                  <button className="course_master__sample_file_download" onClick={handleTemplateCourseDownload} style={{padding: '6px 15px'}}>                              
                    <span>Download Template <IoMdDownload style={{"vertical-align": "text-bottom",marginLeft: "2px"}} /></span>                
                  </button>
                </div>            
                <Stack sx={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
                  <Stack spacing={2} direction={"row"} alignItems={"center"}>
                    <input type="file" accept=".xlsx" ref={ref} id="file" onChange={saveFile} hidden />
                    <label className="th-mainData" for="file">
                      Select File
                    </label>
                    <span className="th-file_caption">
                      {file ? file.name : "No File Selected"}
                    </span>
                    <Button
                      className={
                        loading === false
                          ? "th-upload_button_modal_active"
                          : "th-upload_button_modal_inactive"
                      }
                      onClick={handleUpload}
                      sx={{ marginTop: "10px", marginLeft: "20px" }}
                    >
                      {loading === false ? "Upload" : "Cancel"}
                    </Button>
                    {isFileUploaded && <Alert className="file-status" severity={severity} onClose={() => setIsFileUploaded(false)}>{uploadStatusMsg}</Alert>}
                  </Stack>
                </Stack>
              </div>
              {/* <Box
                justifyContent={"center"}
                className="text-filed-box"
                display="flex"
                alignItems={"center"}
              >
                <CssTextField
                  placeholder="Search for help by course name"
                  id="outlined-start-adornment"
                  sx={{ m: 1, width: "30ch", align: "center" }}
                  value={searchVal}
                  onChange={searchFunction}
                  size="small"
                  margin="dense"
                  InputProps={{
                    endAdornment: (
                      <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                />
              </Box> */}
              <Paper sx={{ width: "100%", marginTop: "10px" }}>
                <TableContainer sx={{ maxHeight: 440 }} className="courseMasterTable">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              top: 0,
                              minWidth: column.minWidth,
                              color: "#fff",
                              backgroundColor: "#550A69",
                            }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
    
                    {/* {islogFetchAlert ? (
             <Alert
              severity={islogDataFetched ? "error" : "success"}
              style={{
               maxWidth: "fit-content",
               position: "absolute",
               top: "60px",
               right: "0px",
               zIndex: "99",
               backgroundColor: islogDataFetched ? "#ff3246" : "#05f0a5",
               color: "white",
              }}
              onClose={() => {
               setIslogFetchAlert(false);
              }}
             >
              {islogDataFetched ? "Oops! Failed to fetch data.." : null}
             </Alert>
            ) : null} */}
    
                    {loading ? (
                      <Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                        <CircularProgress color="secondary" centered />
                      </Box>
                    ) : (
                      <TableBody>
                        {filteredData != undefined &&
                          filteredData.length != 0 &&
                          filteredData
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((item, index) => (
                              <TableRow key={index}>
                                <TableCell align="center" scope="row">
                                  {index+1}
                                </TableCell>
                                <TableCell align="center">{item.primary_skill}</TableCell>
                                <TableCell align="center">{item.span}</TableCell>
                                <TableCell align="center">{item.ssi_bundle}</TableCell>
                                
                                <TableCell
                                  align="center"
                                  onClick={() => {
                                    setOpen(item.id);
                                  }}
                                  sx={{ cursor: "pointer" }}
                                >
                                 <DeleteOutlineIcon/> 
                                </TableCell>
                              </TableRow>
                            ))}
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
                <TablePagination
                  className="courseMasterTable_pagination"
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={
                    filteredData && filteredData.length > 0 ? filteredData.length : 0
                  }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Stack>
            
    </ThemeProvider>
    <DeleteConfirmationModal
        open={open}
        onCancel={() => setOpen(null)}
        onConfirm={()=>handleDelete(open)}
        deleting={deleting}
        title="Delete Course"
        message="Are you sure you want to delete this Course? This action cannot be undone."
      />
      </>
  )
}

export default CourseMaster